module.exports = __webpack_public_path__ + "static/media/CUTI.7824a361.png";